export enum PopupState {
  Success = 'success',
  Error = 'error',
  Info = 'info',
}

export interface PopupAction {
  href: string
  buttonText: string
}
